import { Button, Dialog, DialogActions, DialogContent, ListSubheader, Stack } from '@mui/material'
import DraggableDialogTitle from '../../../common/DraggableDialogTitle'
import { OptionChainViewKey } from '../../../../assets/constants'
import { useFullscreenContainer } from '../../../../hooks/useFullscreenContainer'
import OptionChainQuickViewMenu from '../../../optionChain/header/optionChainQuickViewMenu'
import OptionChainTimeIntervalMenu from '../../../optionChain/header/optionChainTimeIntervalMenu'
import OptionChainSettingsForm from '../../../../pages/home/fnoHeader/optionChainSettingsForm'
import { WidgetSettingsMenuProvider } from '../../widgetSettingsMenuContext'

type Props = {
    open: boolean
    onClose: () => void
    optionChainViewKey?: OptionChainViewKey
}

const listSubheaderSx = {
    lineHeight: '24px',
    backgroundColor: 'unset',
    fontSize: 12,
    opacity: 0.5,
    mt: 0,
    px: 0,
}

const OptionChainWidgetSettingsDialog = ({
    open,
    onClose,
    optionChainViewKey = OptionChainViewKey.WIDGET
}: Props) => {
    const fullscreenContainer = useFullscreenContainer()

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            container={fullscreenContainer ?? undefined}
        >
            <DraggableDialogTitle>Option Chain Settings</DraggableDialogTitle>
            <DialogContent sx={{ pb: '0 !important', overflowY: 'auto' }}>
                <WidgetSettingsMenuProvider>
                <Stack gap={1.5} sx={{ py: 0.5 }}>
                    <Stack gap={0.5}>
                        <ListSubheader sx={listSubheaderSx}>QUICK VIEW</ListSubheader>
                        <OptionChainQuickViewMenu orderOptionChain={false} optionChainViewKey={optionChainViewKey} />
                    </Stack>
                    <Stack gap={0.5}>
                        <ListSubheader sx={listSubheaderSx}>TIME INTERVAL</ListSubheader>
                        <OptionChainTimeIntervalMenu orderOptionChain={false} optionChainViewKey={optionChainViewKey} />
                    </Stack>
                    <OptionChainSettingsForm orderOptionChain={false} optionChainViewKey={optionChainViewKey} />
                </Stack>
                </WidgetSettingsMenuProvider>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={onClose}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default OptionChainWidgetSettingsDialog
